// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Divider_wrapper__mGILZ"};